import React, { useEffect, useState } from 'react';
import { Modal, Button, Upload, Input, message, Select, Typography, Space, Row, Col, Card } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { exportAddon } from '@/apis/addons';
import { useNavigate } from "react-router-dom";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { RESOURCE_TYPE_ADDONS } from '@/resources-def';

const { TextArea } = Input;

export const ExportAddon = ({ id }) => {
  const navigate = useResourceNavigate();
  const [fileContent, setFileContent] = useState(null);
  const [fileName, setFileName] = useState('');
  const [versions, setVersions] = useState([]);

  useEffect(() => {
    const callExportAddon = async () => {
      const contentObj = await exportAddon( id );
      if(contentObj) {
        setFileContent(contentObj);
        setFileName(contentObj.name);
        setVersions([contentObj?.version]); 
      }
    }
    callExportAddon();
  }, [ id ]);

  const handleCancel = () => {
    navigate({ resource: "settings/" + RESOURCE_TYPE_ADDONS, action: "list" });
  };

  const handleExport = () => {
    if (!fileContent || !fileName) {
      message.error('Please select file first!');
      return;
    }

    const content = JSON.stringify({...fileContent, versions: fileContent.versions.filter((version) => versions.indexOf(version.version) != -1)}, null, 2);
    const exportName = fileName || '';

    const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
    
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `Addon-${exportName}.json`;
    document.body.appendChild(link);
    link.click();
    
    setTimeout(() => {
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    }, 0);

    message.success('Export addon successfully');
    navigate({ resource: "settings/" + RESOURCE_TYPE_ADDONS, action: "list" });
  };

  const clear = () => {
    setFileContent(null);
    setFileName('');
    setVersions([]);
  }

  return (
    <>
      <Card title={`Export Profile`} 
        style={{ maxWidth: 900, minHeight: 200, marginTop: 0, width: "100%", height: "100%"}}>
        <Space direction="vertical" size={16} style={{ width: '100%' }}>
        <Row align="middle" gutter={12}>
          <Col span={2}>
          <label>Name</label>
          </Col>
          <Col span={18}>
            <Input style={{ width: '80%' }} value={fileName}/>
          </Col>
        </Row>
        <Row align="middle" gutter={12}>
          <Col span={2}>
            <label>Version</label>
          </Col>
          <Col span={18}>
            <Select
              mode={'multiple'}
              value={versions}
              onChange={(vals) => setVersions(vals)}
              placeholder="Please select the addon"
              style={{ width: '80%' }}
            >
              {fileContent?.versions?.map((version) => (
                <Option key={version.version} value={version.version}>
                  {version.version}
                </Option>
              ))}
            </Select>
          </Col>
        </Row>
        <div style={{ flex: 1, minHeight: 100 }}>
          <label style={{ marginRight: 16 }}>Definition</label>
          <TextArea
            value={fileContent != null ? JSON.stringify({...fileContent, versions: fileContent.versions.filter((version) => versions.indexOf(version.version) != -1)}, null, 2) : ""}
            placeholder="Addon Preview"
            readOnly
            rows={20}
            style={{
              height: '100%',
              resize: 'none',
              fontFamily: 'monospace',
              whiteSpace: 'pre-wrap'
            }}
          />
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button type="primary" onClick={handleExport}>
            Export
          </Button>
        </div>
        </Space>
      </Card>
    </>
  );
};